import { render, staticRenderFns } from "./academic_font.vue?vue&type=template&id=5a048c1a&scoped=true&"
import script from "./academic_font.vue?vue&type=script&lang=js&"
export * from "./academic_font.vue?vue&type=script&lang=js&"
import style0 from "./academic_font.vue?vue&type=style&index=0&id=5a048c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a048c1a",
  null
  
)

export default component.exports